import React from "react";
import styled from "styled-components";
import me from "../assets/images/me.jpg";


const StyledSection = styled.section`
  width: 100%;
  max-width: 80vw;
  position: relative;
  margin: 0 auto;

  .heading {
    h2 {
      color: var(--white);
      flex-shrink: 0;
    }

    position: relative;

    display: flex;
    column-gap: 70px;
    justify-content: space-between;

    align-items: center;
    &:after {
      content: "";
      background: white;
      box-sizing: border-box;
      display: inline-block;
      height: 1px;
      width: 100%;
    }
  }
  section {
    color: var(--gray-1);
    padding-top: 40px;
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 50px;
    .text {
      margin-right: 100px;
      ul {
        margin-top: 20px;
        position: relative;
        display: grid;
        grid-template-columns: 2fr 2fr;

        li {
          position: relative;
          margin-bottom: 10px;
          padding-left: 20px;
          &:before {
            content: "▹";
            position: absolute;
            left: 0px;
            color: var(--gradient);
            font-size: 1.5rem;
          }
        }
      }
    }
  }
  #image {
    .picture {
      width: 400px;
      height: 400px;
      position: relative;
      img {
        border-radius: 22px;
      }

      &:after {
        border: 2px solid #aee8fa;
        top: 15px;
        left: 20px;
        z-index: -1;
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 12px;
      }
    }
  }

  @media (max-width: 799px) {
    .heading {
      h2 {
        font-size: 3.5rem;
      }
    }
    section {
      display: block;
      max-width: 100% !important;
      padding: 0;
      .text {
        margin: 0;
      }
      #image {
        position: relative;
        display: inline-block;
        margin: 50px auto 0px;
        width: 70%;
      }
    }
  }
  @media (max-width: 575.98px) {
    #image {
      img {
        width: 80%;
      }
    }

    section #image .picture:after {
      top: 10px;
      left: 10px;

      width: 80%;
    }
  }
`;

const About = ({ scrollRef }) => {
  return (
    <StyledSection ref={scrollRef}>
      <div className="heading" id="about-start">
        <h2>About Me</h2>
      </div>
      <section>
        <div className="text">
          <p>
            Hello! My name is Zayn, and I build full-stack web applications that
            are fast, maintainable, and production ready. I graduated with a BSc
            in Computer Science from UBC in 2025 and have been shipping
            professional software since 2022.
            <br />
            <br />
            Today I work as a Software Developer at Recollective Inc., where I
            am one of five engineers on a founding team building a new SaaS
            platform from the ground up. I own features end to end from database
            schema to UI, across a Vue/Nuxt frontend and a Spring Boot backend.
            <br />
            <br />
            Before that, I spent nearly two years at Jostle Corporation as a UI
            Developer, where I improved search UX with React, Redux, and
            GraphQL, reduced UI rendering time by 40%, and reviewed 130+ pull
            requests. Both Jostle and Recollective extended offers after my
            co-op terms.
            <br />
            <br />
            Here are a few technologies I have been working with recently:
            <br />
          </p>
          <ul>
            <li>React.js</li>
            <li>Vue.js</li>
            <li>Next.js</li>
            <li>TypeScript</li>
            <li>Spring Boot</li>
            <li>Node.js</li>
            <li>GraphQL</li>
            <li>Docker</li>
          </ul>
        </div>
        <div id="image">
          <div className="picture">
            <img src={me} alt="zayn chowdhury" />
          </div>
        </div>
      </section>
    </StyledSection>
  );
};

export default About;
